import { useMutation, useQueryClient } from "@tanstack/react-query";
import { adminUserDetailKeys } from "Api/Queries/User/useAdminUserDataQuery";
import { USERS_LIST_QUERY_KEY } from "Api/Queries/User/useUsersListQuery";
import { usersNotVerifiedKeys } from "Api/Queries/User/useUsersNotVerifiedQuery";
import { getVerificationsQueryKey } from "Api/Queries/Verifications/useVerificationsQuery";
import {
  type SetIdentityVerificationStatusCommand,
  putUsersIdentityVerificationStatus,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useSetIdentityVerificationStatusMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (data: SetIdentityVerificationStatusCommand) =>
        putUsersIdentityVerificationStatus(data),
    ),
    onSuccess: (_, { targetUserID }: SetIdentityVerificationStatusCommand) => {
      queryClient.invalidateQueries({
        queryKey: adminUserDetailKeys.detailByUserID(targetUserID),
      });
      queryClient.invalidateQueries({
        queryKey: getVerificationsQueryKey(targetUserID), //TODO: nice to have: refactor to use the object query keys approach
      });
      queryClient.invalidateQueries({
        queryKey: [USERS_LIST_QUERY_KEY], //TODO: nice to have: refactor to use the object query keys approach
      });
      queryClient.invalidateQueries({
        queryKey: usersNotVerifiedKeys.all,
      });
      onSuccess?.();
    },
    onError,
  });
};
